import { WidgetsSupportChatConversationsList } from '@/widgets/support-chat';

export const PagesSupportMain = () => <WidgetsSupportChatConversationsList />;
